import { styled } from '../../../../../base';

export const FilterContainer = styled('div')(({ theme }) => ({
    margin: theme.spacing(2, 0),
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3, 2),
}));
